export const PAGE_PATH = '/admin-user';
